<template>
 <div class="">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="年月:">
          <el-date-picker
            v-model="searchFrom.month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :clearable="false"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="审核状态:" >
          <el-select v-model="searchFrom.auditStatus"  placeholder="请选择">
            <el-option label="全部" value="" ></el-option>
            <el-option label="待审核" value="待审核" ></el-option>
            <el-option label="审核中" value="审核中" ></el-option>
            <el-option label="已通过" value="已通过" ></el-option>
            <el-option label="已驳回" value="已驳回" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamId" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-select v-model="searchFrom.driverName" filterable placeholder="请选择">
            <el-option v-for="item in sijiList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" v-if="btnFlg[1]" :disabled="isDisable">导出</el-button>
            <el-button type="primary" size="mini" @click="shengChengFn('searchFrom')" v-if="btnFlg[2]">生成</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" style="width: 100%" height="100%" center border class="tableComent">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column width="130" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="gengxinFn(scope.row)" v-if="btnFlg[3]">更新</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="month" label="年月" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="detailFn(scope.row)">{{ scope.row.month }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="driverCount" label="司机人数" min-width="100"></el-table-column>
        <el-table-column prop="totalHaulVolume" label="总拉运量(吨)" min-width="130"></el-table-column>
        <el-table-column prop="totalHaulVolumePiece" label="总拉运量(件)" min-width="130"></el-table-column>
        <el-table-column prop="totalFreightPayable" label="总运费应付(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalOilDeduct" label="总加油扣除(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalGasDeduct" label="总加气扣除(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalTollDeduct" label="总路桥扣除(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalBonus" label="总奖金(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalPenalty" label="总罚金(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalSubsidy" label="总司机补助(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalTripFee" label="总应付趟费(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalPensionDeduct" label="总养老代扣(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalUnemploymentDeduct" label="总失业代扣(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalMedicalDeduct" label="总医疗代扣(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalDeductions" label="总合计代扣(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalNetPay" label="总实发工资(元)" min-width="130"></el-table-column>
        <el-table-column prop="totalPlatformAmount" label="总付平台金额(元)" min-width="130"></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="130"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 生成 -->
    <el-dialog title="生成" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeSC" center width="500px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" class="demo-form-inline" label-width="150px" :inline="false" size="small" v-if="dialogVisible">
        <div class="addinpBox">
          <el-form-item label="年月:" prop="month">
            <el-date-picker
              v-model="addForm.month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              :picker-options="pickerOptions"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" :loading="addLoading">保 存</el-button>
        <el-button @click="closeSC" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" @close="shFlag = false"  :visible.sync="shFlag" width="400px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="shForm" :model="shForm" class="demo-form-inline jiaoyan"  label-width="100px" size="mini">
          <el-form-item label="审核状态:" prop="auditResult">
            <template >
              <el-radio-group v-model="shForm.auditResult"  >
                <el-radio label="pass">通过</el-radio>
                <el-radio label="reject">驳回</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="驳回原因:" class="item1" prop="remark" v-if="shForm.auditResult=='reject'">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="shForm.remark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shFlag = false">取 消</el-button>
        <el-button type="primary" @click="SHFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { driverPayrollSummaryList, driverPayrollSummaryGenerate, driverPayrollSummaryUpdate, tDriverAccountingDelete, tDriverAccountingAudit } from '@/api/newTMS'
import { organizationTree, cDlists } from '@/api/vgs-driver2.0'
export default {
  components: {
  },
  data () {
    return {
      emptyFn: emptyFn,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      XDList: [],
      sijiList: [],
      btnFlg: [],
      btnIdArr: ['01N02H0100', '01N02H0200', '01N02H0300', '01N02H0400'],
      dialogVisible: false,
      addForm: {},
      addLoading: false,
      rules: {
        month: [
          { required: true, message: '请选择年月', trigger: 'change' }
        ],
        auditResult: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          const now = new Date()
          const currentYear = now.getFullYear()
          const currentMonth = now.getMonth()

          const selectYear = time.getFullYear()
          const selectMonth = time.getMonth()

          if (selectYear > currentYear) {
            return true
          }
          if (selectYear === currentYear && selectMonth > currentMonth) {
            return true
          }
          return false
        }
      },
      shFlag: false,
      shForm: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    // this.yearMonthDate = this.getNextMonth()
    this.searchFn()
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 205) + 'px'
  },
  methods: {
    getNextMonth () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    // 获取列表
    getList () {
      this.loading = true
      // let strMonth = this.yearMonthDate.split('-')
      // this.$set(this.searchFrom, 'year', Number(strMonth[0]))
      // this.$set(this.searchFrom, 'month', Number(strMonth[1]))
      driverPayrollSummaryList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.sum = res.map
        this.loading = false
      })
    },
    carChange (e) {
      if (e) {
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.id == e)
        this.sijiList = []
        this.$set(this.searchFrom, 'driverName', '')
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
      }
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/driverPayrollSummary/exportSummary',
        form,
        '司机薪资汇总表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      // this.yearMonthDate = this.getNextMonth()
      this.searchFn()
    },
    closeSC () {
      this.dialogVisible = false
      this.initAddForm()
    },
    initAddForm () {
      this.addForm = {}
    },
    shengChengFn () {
      this.dialogVisible = true
    },
    saveFn () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverPayrollSummaryGenerate(this.addForm)
            .then(res => {
              console.log(res)
              loading.close()
              this.dialogVisible = false
              this.getList(this.searchFrom)
              this.initAddForm()
              this.$message.success('生成成功')
            })
            .catch(err => {
              this.addLoading = false
              console.log(err)
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          this.addLoading = false
        }
      })
    },
    gengxinFn (row) {
      this.$confirm('是否执行更新操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        driverPayrollSummaryUpdate({
          summaryId: row.id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        tDriverAccountingDelete({
          summaryId: row.id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    detailFn (row) {
      // 向父组件发送跳转事件，并传递当前行的id
      this.$emit('switchToDetails', row.id)
    },
    // 审核
    shenHeFn (row) {
      this.shFlag = true
      this.$set(this.shForm, 'summaryId', row.id)
    },
    SHFn () {
      this.$refs.shForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          tDriverAccountingAudit(this.shForm).then(res => {
            loading.close()
            this.shFlag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
